import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, concatMap, map, of, throwError } from 'rxjs';
import { CancelWizardDataV26Service } from 'src/app/services-v26/wizards/cancel-user-wizard-data-v26.service';
import { TerminateMultiAssetWizardActions } from '.';
import { State } from './state';

@Injectable()
export class TerminateMultiAssetWizardEffects {
  // loadReplaceProductWizards$ = createEffect(
  //   () =>
  //     this.actions$.pipe(
  //       ofType(TerminateMultiAssetWizardActions.selectInitStep),
  //       tap(() => this.router.navigateByUrl('/pages/allocation-wizards/order'))
  //     ),
  //   { dispatch: false }
  // );
  // exitTerminateMultiAssetAllocationWizards$ = createEffect(
  //   () =>
  //     this.actions$.pipe(
  //       ofType(TerminateMultiAssetWizardActions.exitAllocationTerminateMultiAssetWizard),
  //       tap(() => this.router.navigateByUrl('/pages/consumers'))
  //     ),
  //   { dispatch: false }
  // );

  newTerminateMultiAsset$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TerminateMultiAssetWizardActions.createNewTerminateMultiAsset),
      concatMap(({ request }) =>
        this.cancelWizardService.cancelLicenseServices(request).pipe(
          map((response) => {
            if (response) {
              return TerminateMultiAssetWizardActions.createNewTerminateMultiAssetSuccess({
                response: response.data,
              });
            } else {
              throwError('No data received');
            }
          }),
          catchError((error) => {
            let errorMessage = '';
            if (error instanceof HttpErrorResponse) {
              errorMessage = error.error.errorKey;
            } else {
              errorMessage = error;
            }
            return of(TerminateMultiAssetWizardActions.createNewTerminateMultiAssetFail({ errorMessage }));
          }),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private cancelWizardService: CancelWizardDataV26Service,
  ) {}
}
